import * as React from 'react';
import '../focus_area/index.js';
import '../list/index.js';
import { FocusArea } from '../focus_area/focus_area.js';
import { ListItem } from '../list/list_item.js';

/**
 * Thin wrapper around ListItem with appropriate default values for rendering in InfiniteList
 */
const InfiniteListItem = ({ children, context, // Destructured so that we wouldn't pass it on to ListItem
item, // Destructured so that we wouldn't pass it on to ListItem
...rest }) => (React.createElement(FocusArea, null,
    React.createElement(ListItem, { ...rest }, children)));

export { InfiniteListItem };
